import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Input, Container, Spinner, Modal, ModalHeader, ModalBody,Table } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import axios from "axios";
import ActivityLog from "./ActivityLog";
import TermsConditions from "./TermsConditions";
import Guidelines from "./Guidelines";
import Menu from "./Menu";

const RatingGroup = [
	{ 
		label: "Rating",
		options: [
                { label: "1", value: "1" },
                { label: "2", value: "2" },
                { label: "3", value: "3" },
                { label: "4", value: "4" },
                { label: "5", value: "5" },
		]
	}
];

class EditHotel extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 3, 'edit' )){
      this.props.history.push('/hotels')
    }
    this.state = {
      gallery_loading:false,
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",
      image_id:"",
      default_image: null,
      loading: false,
      selectedFiles: [],
      rejectedFiles:[],
      facilityloding:false,
      imagesloading:false,
      typeloading:false,
      sq2: true,
      hotel:false,
      
      breadcrumbItems: [ ],
      description:"",
      selectedType: "",
      selectedFacilities:[],
      selectedRating:{ }, 
      selectedLocationsGroup: "",
      selectedDestination:"",
      DestinationGroup:[],
      LocationGroup :[],
      FacilityGroup: [],
      RoomGroup:"",
      TypeGroup:"",
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }

    this.onPlaceInputChange = this.onPlaceInputChange.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFacilitySubmit = this.handleFacilitySubmit.bind(this);
    this.handleHotelTypeSubmit = this.handleHotelTypeSubmit.bind(this);
    this.handleImageSubmit = this.handleImageSubmit.bind(this);
    this.handleSelectLocationGroup = this.handleSelectLocationGroup.bind(this);
    this.handleSelectDestinationGroup = this.handleSelectDestinationGroup.bind(this);
    this.handleselectedTypeGroup = this.handleselectedTypeGroup.bind(this);
    this.handleselectedRatingGroup = this.handleselectedRatingGroup.bind(this);
    this.handleselectedFacilityGroup = this.handleselectedFacilityGroup.bind(this);
    this.handleDefaultImage = this.handleDefaultImage.bind(this);
    this.handleAddImageNameSubmit = this.handleAddImageNameSubmit.bind(this)
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.handleRejectedFiles = this.handleRejectedFiles.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.tog_images = this.tog_images.bind(this);
    this.tog_type = this.tog_type.bind(this);
    this.tog_img_name = this.tog_img_name.bind(this)
    
  }


  tog_center() {
    this.setState(prevState => ({
      model_facilities: !prevState.model_facilities
    }));
    this.removeBodyCss();
  }
  tog_images() {
    this.setState(prevState => ({
      model_images: !prevState.model_images
    }));
    this.removeBodyCss();
  }

  tog_img_name() {
    this.setState(prevState => ({
      model_img_name: !prevState.model_img_name
    }));
    this.removeBodyCss();
  }

  tog_type() {
    this.setState(prevState => ({
      model_type: !prevState.model_type
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/hotels')
  }

  async componentDidMount() {
 
    this.loadData();
    this.loadTypesData()
    this.loadFacilitiesData()
    this.loadDestinationData('?parent=null')
 }

 loadData(){
    const id =this.props.match.params.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    fetch(`${BaseUrl}/api/hotels/hotels/${id}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {  
                document.title = "Edit "+data.hotel.name+" | Planmans";
                let breadcrumbItems= [
                    { title: "Hotels", link:"/hotels"},
                    { title: ` ${data.hotel.name}`, link: `/hotel/${data.hotel.id}` },
                    { title: `Edit ${data.hotel.name}`, link: "#" },
                  ]  
                let selectedRating = { label: data.hotel.rating, value: data.hotel.rating }     
                let selectedLocationsGroup = { label: data.hotel.place.name, value: data.hotel.place.id }
                let selectedDestination = { label: data.hotel.destination.name, value: data.hotel.destination.id }
                let selectedType = { label: data.hotel.hotel_type.name, value: data.hotel.hotel_type.id }
                let facilities = data.hotel.facilities
                let selectedFacilities = []
                for(let i=0; i<facilities.length; i++ ){
                    selectedFacilities.push({label: facilities[i].name, value: facilities[i].id})
                }
                let default_image = null
                for(let i=0; i< data.hotel.images.length; i++){
                  if (data.hotel.images[i].is_default){
                    default_image = data.hotel.images[i]
                  }
                }
                this.loadPlacesData(`?parent__id=${data.hotel.destination.id}`)
                                  
                this.setState({ hotel:data.hotel, 
                                breadcrumbItems:breadcrumbItems,
                                selectedRating:selectedRating,
                                selectedLocationsGroup:selectedLocationsGroup,
                                selectedDestination:selectedDestination,
                                selectedFacilities:selectedFacilities,
                                selectedType:selectedType,
                                default_image:default_image,
                                gallery_loading:false,
                                model_img_name:false,
                                imagenameloading:false})    
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 
  }
  async loadDestinationData(filer_queryset){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(destination => {
                    options.push({ label: destination.name, value: destination.id })
                  })
               
                  let DestinationGroup = [
                    { 
                        label: "Destination",
                        options: options
                    }
                ];
                this.setState({ DestinationGroup:DestinationGroup  })      
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }

 async loadTypesData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/hotels/hotels_types/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(type => {
                options.push({ label: type.name, value: type.id })
              })
              let TypeGroup = [
                { 
                  label: "Hotel Type",
                  options: options
                }
              ];
              this.setState({ TypeGroup: TypeGroup })           
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadFacilitiesData(){
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
  };
  await fetch(`${BaseUrl}/api/hotels/hotels_facilities/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              // Add Select All option first
              options.push({ label: "Select All", value: "all" });
              // Add facilities from API
              data.map(facility => {
                options.push({ label: facility.name, value: facility.id })
              })
              let FacilityGroup = [
                { 
                  label: "Facilities",
                  options: options
                }
              ];
              this.setState({ FacilityGroup: FacilityGroup })           
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
}

  async loadPlacesData(filer_queryset){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(place => {
                    options.push({ label: place.name, value: place.id })
                  })
              
                  let LocationGroup = [
                    { 
                        label: "Places",
                        options: options
                    }
                ];
                this.setState({ LocationGroup:LocationGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }


 handleAcceptedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ selectedFiles: files });
};

handleRejectedFiles = files => {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: this.formatBytes(file.size)
    })
  );
  this.setState({ rejectedFiles : files });
} 


/**
 * Formats the size
 */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  onInputChange(e){
    this.loadDestinationData(`?parent=null&search=${e}`)
  }

  onPlaceInputChange(e){
    if (this.state.selectedDestination.value)
      this.loadPlacesData(`?parent__id=${this.state.selectedDestination.value}&search=${e}`)
  }


 handleselectedTypeGroup = selectedType =>{
     this.setState({ selectedType })
 }

 handleselectedFacilityGroup = selectedFacilities => {
  // Check if "Select All" was selected
  const hasSelectAll = selectedFacilities.some(option => option.value === "all");
  
  if (hasSelectAll) {
    // Get all facilities except "Select All" option
    const allFacilities = this.state.FacilityGroup[0].options
      .filter(opt => opt.value !== "all")
      .map(opt => ({ label: opt.label, value: opt.value }));
    this.setState({ selectedFacilities: allFacilities });
  } else {
    this.setState({ selectedFacilities });
  }
};

  handleSelectLocationGroup = selectedLocationsGroup => {
    this.setState({ selectedLocationsGroup });
  };

  handleSelectDestinationGroup = selectedDestination => {
    this.loadPlacesData(`?parent__id=${selectedDestination.value}`)
    let selectedLocationsGroup = { label: "Select Place", value: "" }
    this.setState({ selectedDestination,selectedLocationsGroup });
  };

  handleselectedRatingGroup = selectedRating => {
    this.setState({ selectedRating });
  }
  
  handleAddImageNameSubmit(e, values){
    const { selected_img } = this.state
    if (selected_img){
      this.setState({imagenameloading:true})
    let data = {"name": values.name}
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/images/${selected_img.id}/`,requestOptions)
      .then(res => 
          {if(res.status >= 400){
              res.json()
              .then(
                  (data) =>{  
                    console.log(data, "error data") 
                    this.setState({ model_img_name:false, imagenameloading:false })
                  }     
              )
          }
          else{
            this.loadData()
          }    
      }
    )

    }else{
      toastr.error("Somthing went wrong", "Please Try Again")
      this.setState({ model_img_name:false, imagenameloading:false })
    }
    

  }

  handleDefaultImage = item =>{
    this.setState({ gallery_loading:true })
    let data ={}
    data['name'] = item.name
    data['is_default'] = true
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/locations/location/images/${item.id}/`,requestOptions)
      .then(res => 
          {if(res.status >= 400){
              res.json()
              .then(
                  (data) =>{  
                    console.log(data, "error data")
                    toastr.error("Something Went Wrong", "") 
                    this.setState({ gallery_loading:false})
                  }     
              )
          }
          else{
              res.json()
              .then(
                  (data) =>{
                    
                    const {default_image} = this.state
                    if (default_image){
                      let newdata ={}
                      newdata['name'] = default_image.name
                      newdata['is_default'] = false
                      const requestOptions = {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
                        body: JSON.stringify(newdata)
                        };
                        fetch(`${BaseUrl}/api/locations/location/images/${default_image.id}/`,requestOptions)
                        .then(res => 
                            {if(res.status >= 400){
                                res.json()
                                .then(
                                    (data) =>{  
                                      console.log(data, "error data") 
                                      this.setState({ gallery_loading:false})
                                    }     
                                )
                            }
                            else{
                              this.loadData()
                            }    
                        }
                      ) 

                    }else{
                      this.loadData()
                    }

                  }
              )
          }    
      }
    )
  } 


  handleImageClicks = id => {    
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${this.obj.access}` },
    
        };
          fetch(`${BaseUrl}/api/locations/location/images/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                      console.log("error")
                    }
                    else{
                      this.loadData();
                      this.setState({
                        image_id:"",
                        success_confirm: true,
                        alert_confirm : false,
                        dynamic_title: "Deleted!",
                        gallery_loading: true,
                        dynamic_description: "Image has been deleted."
                        })
                        this.loadData()
                    }
                }
            )
    }

  handleImageSubmit(e, values){
    if(this.state.selectedFiles.length === 0){

      toastr.error(`Select Images`,"") 
    }
    else{

        this.setState({imagesloading:true})
        const { hotel,selectedFacilities } = this.state
        const formData = new FormData();
        const img = this.state.selectedFiles
        for(let i=0 ; i<img.length; i++){
          formData.append(
            "image",
            this.state.selectedFiles[i]
          );
        }
        formData.append("name",values.image_name)
        axios.post(
          `${BaseUrl}/api/locations/images/`,
          formData,
          {
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },                
          }
        )
        .then(res => {         
          let description = document.getElementById("textarea").value
          let facilities = []
          for (let i =0; i<selectedFacilities.length; i++){
            facilities.push(selectedFacilities[i].value)
          }

          let images = []
          for(let i=0 ; i<hotel.images.length; i++){
              images.push(hotel.images[i].id)
            
          }
          for(let i=0 ; i<res.data.length; i++){
            images.push(res.data[i].id)
          
          }          
          let data = {}
          data["name"] = values.name
          data["hotel_type"] = this.state.selectedType.value
          data["rating"] = this.state.selectedRating.value
          data["place"] = this.state.selectedLocationsGroup.value
          data["address"] = values.address
          data["zip_code"] = values.zip_code
          data["coordinates"] = values.coordinates
          data["facilities"] = facilities
          data["description"] = description
          data['images'] = images
          const requestOptions = {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
              body: JSON.stringify(data)
              };
              fetch(`${BaseUrl}/api/hotels/hotels/${hotel.id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "error data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ imagesloading: false, model_images:false,selectedFiles:[]})
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                            this.loadData()
                            toastr.success("Images Added", "") 
                            this.setState({ imagesloading: false, model_images:false, gallery_loading: true, selectedFiles:[]})
                          
                          }
                      )
                  }    
              }
            )
        })
        .catch(err => {
          toastr.error(`Somthing Went Wrong`,"") 
          this.setState({ imagesloading: false })
            console.log(err, "----------------------error");
          })

        }
    
  }

  handleFacilitySubmit(e, values) {
    this.setState({ facilityloding: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/hotels/hotels_facilities/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ facilityloding: false })
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          this.loadFacilitiesData()
                          this.setState({facilityloding: false, model_facilities: false, })
                          }
                      )
                  }    
              }
          )
  }

  handleHotelTypeSubmit(e, values) {
    this.setState({ typeloading: true })
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/hotels/hotels_types/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ typeloading: false })
                          }     
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                          let selectedType ={ label: data.name, value: data.id }
                          this.setState({typeloading: false, model_type: false, selectedType:selectedType })
                          }
                      )
                  }    
              }
          )
  }

  handleSubmit(e, values) {
    let description = document.getElementById("textarea").value
    if (this.state.selectedFacilities.length === 0) {
      toastr.error(`Select Facilities`,"") 
    }else if (this.state.selectedLocationsGroup.value === ""){
      toastr.error(`Select Place`,"")
    }else{
      this.setState({ loading: true })
      const { selectedFacilities, hotel } = this.state
      let facilities = []
      for (let i =0; i<selectedFacilities.length; i++){
        facilities.push(selectedFacilities[i].value)
      }

      let images = []
      for(let i=0 ; i<hotel.images.length; i++){
          images.push(hotel.images[i].id)
        
      } 
        let data = {}
        data["name"] = values.name
        data["hotel_type"] = this.state.selectedType.value
        data["rating"] = this.state.selectedRating.value
        data["place"] = this.state.selectedLocationsGroup.value
        data["destination"] = this.state.selectedDestination.value
        data["address"] = values.address
        data["zip_code"] = values.zip_code
        data["coordinates"] = values.coordinates
        data["facilities"] = facilities
        data["description"] = description
        data["contact_person"] = values.contact_person
        data["contact_email"] = values.contact_email
        data["contact"] = values.contact
        data['images'] = images
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
            body: JSON.stringify(data)
            };
            fetch(`${BaseUrl}/api/hotels/hotels/${hotel.id}/`,requestOptions)
                  .then(res => 
                      {if(res.status >= 400){
                          res.json()
                          .then(
                              (data) =>{  
                                  console.log(data, "error data")
                                toastr.error("Something Went Wrong", "") 
                                this.setState({ loading: false })
                              }     
                          )
                      }
                      else{
                          res.json()
                          .then(
                              (data) =>{
                                  this.props.history.push(`/hotel/${data.id}`)
                              
                              }
                          )
                      }    
                  }
              )
    }
  }

  render() {
    const {hotel, selectedLocationsGroup, LocationGroup, selectedType, TypeGroup, selectedFacilities,
      FacilityGroup, selectedRating, selectedDestination, DestinationGroup } = this.state;

      const HotelFacility = ({ innerRef, innerProps, isDisabled, children }) =>
      !isDisabled ? (
          <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
              {children}
              <Link to="#" onClick={this.tog_center}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
          </div>
      ) : null;

    const HotelType = ({ innerRef, innerProps, isDisabled, children }) =>
        !isDisabled ? (
            <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                <Link to="#" onClick={this.tog_type}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>

            </div>
        ) : null;


    return (

      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title={""} breadcrumbItems={this.state.breadcrumbItems} />
            <React.Fragment>
                  {!isEmpty(hotel)?
                  <>
                    <Row>
                      <Col xl="6">
                        <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
                        
                            <Card>
                                <CardBody> 
                                <h4 className="card-title">Hotel Detail</h4>
                                    <Row>
                                      <Col md="12">
                                          <div className="mb-3">
                                          <Label className="form-label " htmlFor="name">Hotel Name</Label>
                                          <AvField
                                              name="name"
                                              placeholder="Hotel Name"
                                              type="text"
                                              value={hotel.name}
                                              errorMessage="Enter Hotel Name"
                                              className="form-control"
                                              validate={{ required: { value: true } }}
                                              id="name"
                                              
                                          />
                                          </div>
                                      </Col> 
                                    </Row>

                                    <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Hotel Type</Label>
                                            <Select 
                                            value={selectedType}
                                            onChange={this.handleselectedTypeGroup}
                                            options={TypeGroup}
                                            components={{ Menu: HotelType }}
                                            classNamePrefix="select2-selection"
                                            />
                                        </div>
                                    </Col>

                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Rating</Label>
                                            <Select 
                                            value={selectedRating}
                                            onChange={this.handleselectedRatingGroup}
                                            options={RatingGroup}
                                            classNamePrefix="select2-selection"
                                            />

                                        </div>
                                    </Col>
                            
                                    </Row>
                                    <Row>
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label " htmlFor="address">Address</Label>
                                            <AvField
                                            name="address"
                                            placeholder="Hotel Address"
                                            type="text"
                                            value={hotel.address}
                                            errorMessage="Enter Hotel Address"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                            id="address"
                                            
                                            />
                                        </div>
                                        </Col> 

                                    </Row>
                                    <Row>
                                      <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label">Destination</Label>
                                            <Select 
                                            onInputChange={this.onInputChange}
                                            value={selectedDestination}
                                            onChange={this.handleSelectDestinationGroup}
                                            options={DestinationGroup}
                                            classNamePrefix="select2-selection"
                                            />
                                      </div>
                                      </Col>
                                      <Col md="6">
                                          <div className="mb-3">
                                              <Label className="form-label">Place</Label>
                                              <Select 
                                                  onInputChange={this.onPlaceInputChange}
                                                  value={selectedLocationsGroup}
                                                  onChange={this.handleSelectLocationGroup}
                                                  options={LocationGroup}
                                                  classNamePrefix="select2-selection"
                                              />
                                          </div>
                                      </Col>
                                      
                          
                                  </Row>

                                    <Row>
                                       
                                        <Col md="6">
                                        <div className="mb-3">
                                        <AvField
                                            name="zip_code"
                                            label="Pin Code"
                                            placeholder="Enter Only number"
                                            type="number"
                                            value={hotel.zip_code}
                                            errorMessage="Enter Only Number"
                                            validate={{
                                            required: { value: true },
                                            
                                            maxLength: {
                                                value: 6,
                                                errorMessage: "Numbers must be less than 7 digit"},
                                            minLength: {
                                                value: 6,
                                                errorMessage: "Numbers must be Grater than 5 digit"}   
                                            }}
                                        />
                                        </div>
                                    </Col> 
                            
                                    </Row>
                                    <Row>
                                      <Col md="6">
                                          <div className="mb-3">
                                              <Label className="form-label " htmlFor="elevation">Contact Person</Label>
                                              <AvField
                                              name="contact_person"
                                              placeholder="Contact Person"
                                              type="text"
                                              value= {hotel.contact_person}
                                              errorMessage="Enter Contact Person"
                                              className="form-control"
                                              validate={{ required: { value: true } }}
                                              id="elevation"
                                              
                                              />
                                          </div>
                                      </Col> 
                                      <Col md="6">
                                          <div className="mb-3">
                                          <Label className="form-label " htmlFor="contact"> Contact Number</Label>
                                              <AvField
                                              name="contact"
                                              placeholder="Contact Number"
                                              type="text"
                                              value= {hotel.contact}
                                              className="form-control"
                                              errorMessage="Enter Only Number"
                                              validate={{
                                                  required: { value: true },
                                              }}
                                              id="contact"
                                              
                                              />
                                          </div>
                                      </Col> 
                                    </Row>
                                    <Row>
                                    <Col md="6">
                                        <div className="mb-3">
                                        <Label className="form-label " htmlFor="contact_email"> Contact Email</Label>
                                            <AvField
                                            name="contact_email"
                                            placeholder="Contact Email"
                                            type="text"
                                            value= {hotel.contact_email}
                                            className="form-control"
                                            errorMessage="Enter Contact Person Email"
                                            validate={{
                                                required: { value: true },
                                            }}
                                            id="contact_email"
                                            
                                            />
                                        </div>
                                      </Col> 
                                    <Col md="6">
                                        <div className="mb-3">
                                            <Label className="form-label " htmlFor="coordinates">Location Coordinates</Label>
                                            <AvField
                                            name="coordinates"
                                            placeholder="Hotel Location Coordinates"
                                            type="text"
                                            value={hotel.coordinates}
                                            errorMessage="Enter Hotel Location Coordinates"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                            id="coordinates"
                                            
                                            />
                                        </div>
                                        </Col> 

                                    </Row>
                                    <Row>    
                                    <Col md="12">
                                        <div className="mb-3">
                                            <Label className="form-label">Facilities</Label>
                                            <Select 
                                            value={selectedFacilities}
                                            isMulti={true}
                                            onChange={this.handleselectedFacilityGroup}
                                            options={FacilityGroup}
                                            components={{ Menu: HotelFacility }}
                                            classNamePrefix="select2-selection"
                                            />

                                        </div>
                                    </Col>
                                    </Row>    
                                    <Row>
                                    <div className="mb-3">
                                        <Label className="form-label " htmlFor="price">Description</Label>
                                        <Input
                                            type="textarea"
                                            id="textarea"
                                            rows="3"
                                            defaultValue={hotel.description}
                                            placeholder="About Hotel"
                                        />
                                    </div>
                                    </Row> 
                                    <FormGroup className="mb-0 mt-1">
                                    {this.state.loading?(
                                        <Spinner className="me-2 mt-2" color="primary" />
                                    ):(
                                        <div>
                                    
                                    <Button type="submit" color="primary" className="me-1">
                                        Submit
                                    </Button>{" "}
                                    <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                                        Cancel
                                    </Button>
                                    </div>
                                    )}
                                    
                                    
                                </FormGroup>      

                                </CardBody>
                            </Card>
                      
                        </AvForm>
                      </Col>
                      <Col xl="6">
                        {/*  Gallery Images */}
                        <Card>
                            <CardBody> 
                            <h4 className="card-title">Gallery</h4>
                            {this.state.gallery_loading?
                            <div className="d-flex align-items-center justify-content-center m-5">
                              <Spinner className="me-2 mt-2" color="primary" />
                            </div>
                              :
                              <>
                                <div className="table-responsive">
                                          <Table className="table-nowrap mb-0">
                                            <tbody>
                                            <tr key={'GalleryHeading'}>
                                              <th
                                              scope="row"
                                              >
                                              {"Image"}
                                              </th>
                                              <th
                                              scope="row"
                                              >
                                              {"Name"}
                                              </th>
                                              <th
                                              scope="row"
                                              >
                                              {"Default"}
                                              </th>
                                              <th
                                              scope="row"
                                              >
                                              {"Action"}
                                              </th>
                                              </tr> 
                                              {hotel.images.map((item, i) => (
                                                <tr key={i+"image"}>
                                                  <th
                                                  scope="row"
                                                  >
                                                  <img className="rounded avatar-md" alt="image" src={BaseUrl+item.image} />
                                                  </th>
                                                  <th
                                                  scope="row"
                                                  >
                                                  <p>{item.name}</p>
                                                  </th>
                                                  <th
                                                  scope="row"
                                                  >
                                                    {item.is_default?

                                                        <Input className="form-check-input m-2" type="radio" onChange={() =>this.handleDefaultImage(item)} name="exampleRadios" id={item.id} value={item.id} defaultChecked />
                                                      :
                                                        <Input className="form-check-input m-2" type="radio" onChange={() =>this.handleDefaultImage(item)} name="exampleRadios" id={item.id} value={item.id} />
                                                
                                                    }
                                                  </th>
                                                  <th
                                                  scope="row"
                                                  >
                                                    <Link to="#" onClick={() => this.setState({ selected_img: item, model_img_name:true })}  className="text-danger me-3"><i className="mdi mdi-pencil font-size-18"></i></Link>
                                                    <Link to="#" onClick={() => this.setState({ alert_confirm: true, image_id:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                                  </th>
                                                </tr> 
                                              ))}
                                          


                                            </tbody>
                                          </Table>
                                </div>
                                <Button type="button" className="btn-sm mt-4" onClick={this.tog_images} color="info"><i className=" fas fa-plus"></i></Button>
                              </>}
                            </CardBody>
                        </Card>
                        {/* Menu */}
                        <Menu 
                          hotel ={this.state.hotel}
                          user = {this.obj.user}
                          access = {this.obj.access}
                          history = {this.props.history}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="6">   
                        <Guidelines
                          hotel ={this.state.hotel}
                          user = {this.obj.user}
                          access = {this.obj.access}
                          history = {this.props.history}
                          />
                      </Col>
                      <Col xl="6">  
                        <TermsConditions
                          hotel ={this.state.hotel}
                          user = {this.obj.user}
                          access = {this.obj.access}
                          history = {this.props.history}
                          />
                      </Col>
                    </Row>
                    <ActivityLog
                      hotel ={this.state.hotel}
                      user = {this.obj.user}
                      access = {this.obj.access}
                      history = {this.props.history}
                     /> 
             
                  </>
                :
                <div className="d-flex align-items-center justify-content-center min-vh-100">
            
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
                    <Spinner type="grow" className="me-2" color="secondary" />
            
                </div>}
            </React.Fragment>
            {/* Model Change Image name */}
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_img_name}
                 toggle={this.tog_img_name}
                 centered={true}
               >
                 <ModalHeader toggle={this.tog_img_name}>
                 Change Image Name
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddImageNameSubmit} >
                     <Row>
                       <Col md="8">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="img_name">Name</Label>
                           <AvField
                             name="name"
                             placeholder="Name"
                             type="text"
                             value={this.state.selected_img?.name}
                             errorMessage="Enter Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="img_name"
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.imagenameloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Save
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>

              {/* Add Facilities Model */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
                <Modal
                  isOpen={this.state.model_facilities}
                  toggle={this.tog_center}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_facilities: false })}>
                  Add Hotel Facility
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleFacilitySubmit} >
            
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="name">Hotel Facility</Label>
                            <AvField
                              name="name"
                              placeholder="Hotel Facility"
                              type="text"
                              errorMessage="Enter Hotel Facility"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="name"
                              
                            />
                          </div>
                        </Col> 
                      </Row>
                                        
                      <FormGroup className="mb-0">
                        {this.state.facilityloding?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>

                  </ModalBody>
                </Modal>
              </Col>
              {/* Add Hotel Type Model */}
              <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_type}
                 toggle={this.tog_center}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_type: false })}>
                 Add Hotel Type
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleHotelTypeSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name"> Type Name</Label>
                           <AvField
                             name="name"
                             placeholder="Hotel Type"
                             type="text"
                             errorMessage="Enter Hotel Type"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.typeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>

             <Col sm={6} md={4} xl={3} className="mt-4">
               
                <Modal
                  isOpen={this.state.model_images}
                  toggle={this.tog_images}
                  centered={true}
                >
                  <ModalHeader toggle={() => this.setState({ model_images: false, selectedFiles: [] })}>
                  Add Images
                  </ModalHeader>
                  <ModalBody>
                    <AvForm className="needs-validation" onValidSubmit={this.handleImageSubmit} >
                    <Row>
                      <Col md="12">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="image_name">Name</Label>
                          <AvField
                              name="image_name"
                              placeholder="Name"
                              type="text"
                              errorMessage="Enter Name"
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="image_name" 
                          />
                          </div>
                      </Col> 
                    </Row>
                    <Row>
                          <Col md="12">
                            <Dropzone
                              accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                              maxSize={1000000}
                              onDrop = {(acceptedFiles, fileRejections) => {
                                this.handleRejectedFiles(fileRejections)
                                this.handleAcceptedFiles(acceptedFiles)
                                }}
                              >
                              {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                  <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                  >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                  </div>
                                  <h6>Drop only jpeg/jpg/png Images here or click to upload.</h6>
                                  <h6>Images size is less than 1 MB.</h6>
                                  </div>
                              </div>
                              )}
                            </Dropzone>
                                <div
                                  className="dropzone-previews mt-3"
                                  id="file-previews"
                                  >
                              
                              {this.state.selectedFiles.map((f, i) => {
                              return (
                                  <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                  >
                                  <div className="p-2">
                                      <Row className="align-items-center">
                                      <Col className="col-auto">
                                          <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                          />
                                      </Col>
                                      <Col>
                                          <Link
                                          to="#"
                                          className="text-muted fw-bold"
                                          >
                                          {f.name}
                                          </Link>
                                          <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                          </p>
                                      </Col>
                                      </Row>
                                  </div>
                                  </Card>
                              );
                              })}
                              {this.state.rejectedFiles.length > 0?
                                <>
                                  <hr></hr>
                                  <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                    {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                  </p>
                                </>
                              :""}
                               {this.state.rejectedFiles.map((f, i) => {
                                return (
                                    <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-rejected_file"}
                                    >
                                    <div className="p-2">
                                        <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                            />
                                        </Col>
                                        <Col>
                                            <Link
                                            to="#"
                                            className="text-muted fw-bold"
                                            >
                                            {f.name}
                                            </Link>
                                            <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                            </p>
                                        </Col>
                                        </Row>
                                    </div>
                                    </Card>
                                  );
                                  })}
                            </div>
                          </Col>
                        </Row> 
            
                      
                                        
                      <FormGroup className="mb-0">
                        {this.state.imagesloading?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>     
                    </AvForm>

                  </ModalBody>
                </Modal>
              </Col>


   

          </Container>
        </div>
        {this.state.alert_confirm ? (
          <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => this.handleImageClicks(this.state.image_id)}
          onCancel={() =>
              this.setState({
                  alert_confirm: false,
                  image_id:"",

              })
          }
          >
          You won't be able to revert this!
          </SweetAlert>
        ) : null}

        {this.state.success_confirm ? (
            <SweetAlert
            success
            title={this.state.dynamic_title}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
            >
                {this.state.dynamic_description}
            </SweetAlert>
          )
          : null}
   
      </React.Fragment>
      
    );
  }
}

export default EditHotel;



    